// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rugby/XDL/types";

import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { hexToRGB } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        cssOverrides: {
            datePicker: css`
                .react-datetime-picker {
                    border: 2px solid ${getColor("common.border")};
                    border-radius: 3px;
                }
                .react-calendar {
                    width: 272px; // to fix small mobile screen size issue
                    &__month-view__days__day {
                        border-radius: 0;
                    }
                    &__navigation__label {
                        font-size: 14px;
                    }

                    &__month-view {
                        &__weekdays {
                            font-size: 12px;
                            letter-spacing: 0.41px;
                            line-height: 12px;
                        }
                        &__days {
                            &__day {
                                font-size: 14px;
                                letter-spacing: 0;
                                line-height: 26px;
                                padding: 5px;
                            }
                        }
                    }

                    &__tile {
                        &--active {
                            &:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth) {
                                background-color: ${({ theme }: { theme: BaseTheme }) => {
                                    const primary = resolveColor("primary", theme);
                                    return hexToRGB(primary, 0.13);
                                }};
                                color: ${getColor("text.main")};
                            }
                        }
                        &--now {
                            position: relative;
                            color: ${getColor("text.main")};
                            font-weight: inherit;
                            abbr {
                                position: relative;
                                &::after {
                                    content: " ";
                                    position: absolute;
                                    bottom: -8px;
                                    left: 50%;
                                    -webkit-transform: translateX(-50%);
                                    transform: translateX(-50%);
                                    height: 4px;
                                    width: 4px;
                                    background-color: ${getColor("primary")};
                                    border-radius: 50%;
                                }
                            }
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
